import { render, staticRenderFns } from "./AddAccountSetup.vue?vue&type=template&id=47ab9104&"
import script from "./AddAccountSetup.vue?vue&type=script&lang=js&"
export * from "./AddAccountSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports